import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProblemSolution from "./components/ProblemSolution";
import ArsenalSection from "./components/ArsenalSection";
import PlatformPreview from "./components/PlatformPreview";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-[#0B0F19] min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSolution />
        <ArsenalSection />
        <PlatformPreview />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
